// Bruce Builds — site content & imagery.
// NOTE: Project photos are placeholders until Bruce's real photos are uploaded.

export const PHONE_DISPLAY = "027 275 5782";
export const PHONE_TEL = "tel:0272755782";
export const EMAIL = "hi@brucebuilds.co.nz";

export const services = [
  "Renovations, refurbishments, alterations",
  "Kitchens, bathrooms, decks",
  "Windows, doors and aluminium joinery",
  "Cladding (including cedar and straw bale)",
  "Leak and weathertightness fixes",
  "Framing, roofing, claddings, flashings",
  "Site management and collaborating with sub trades",
  "Council inspections and compliance pathways",
  "Design input and problem solving where it's wanted",
  "Connecting indoor and outdoor living, backed by a landscape design and build background",
];

export const sketches = [
  {
    url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/s0t3v2d6_onehunga_sketch.jpg",
    alt: "Bruce's hand-drawn sketch over the architect's plan — querying a window width that looked too small",
  },
];

export const portrait =
  "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/000622018f43a81f7fd554f940781be79f67a8963888bf51ef429df16d25458a.png";

// Projects — each step has a label + image. Onehunga is the anchor (before → sketch → after).
export const projects = [
  {
    id: "onehunga",
    name: "Onehunga",
    meta: "75m² house extension and 73m² renovation",
    anchor: true,
    steps: [
      {
        label: "Before",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/d2pt0a3b_Resized_09d74e91-5bee-403f-a0cb-88ee9c46aff6~1_328684649042058.jpg",
      },
      {
        label: "Build",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/k12z2xfs_onehunga_build.jpg",
      },
      {
        label: "Deck",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/c7726e79c7bbe3b3e0771d114e7ae4bb019bd1cf110eb932ac311aac43f844ea.png",
      },
    ],
  },
  {
    id: "mteden",
    name: "Mt Eden",
    meta: "100m² premium extension & renovation to an adjoined villa",
    steps: [
      {
        label: "Before",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/cfe14e19715cdece1d9078d3fb924874726765ac9b6123b63134843362b1246b.png",
      },
      {
        label: "Build",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/cfec9eeb331ccf75f0c0a7b3e6a2e4659ceb964039cfed8b7fc29a21cde3cbf8.png",
      },
      {
        label: "After",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/4jqx4re4_mteden_after_2.jpg",
      },
    ],
  },
  {
    id: "blockhousebay",
    name: "Blockhouse Bay",
    meta: "120m² pool house — including truss design, fabrication and construction",
    steps: [
      {
        label: "Before",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/e25ca4517256199b17d904dfb059c9adf957e28f395710cad4c766b1973f73cb.png",
      },
      {
        label: "Build",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/eiuyhcvb_685dc20e-ab63-4416-8ae9-2daa737c80bb.JPG",
      },
      {
        label: "Pool house",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/k1eqv3kw_blockhousebay_poolhouse.jpg",
      },
      {
        label: "After",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/afb6d882b566ac999a6bcf984a2ebc4e8d94f94a4feca71628a79d82c19aa8a3.png",
      },
    ],
  },
  {
    id: "castorbay",
    name: "Castor Bay",
    meta: "Deck rebuild and renovation",
    steps: [
      {
        label: "Before",
        url: "https://customer-assets.emergentagent.com/job_company-14/artifacts/jb9sgvvj_castorbay_before.jpg",
      },
      {
        label: "After",
        url: "https://static.prod-images.emergentagent.com/jobs/c15afa14-0996-4456-81f7-d37b170276e3/images/513c6e8435b863a75476494495ced9223bc30f6f1628d2438b7a274d0c5d3883.png",
      },
    ],
  },
];

export const highlights = [
  "120m² pool house, Blockhouse Bay — including truss design and construction",
  "100m² premium extension and renovation to an adjoined villa, Mt Eden",
  "75m² house extension and 73m² renovation, Onehunga",
  "Lead carpenter, cedar cladding, bespoke Fire Station, Grey Lynn",
];

export const reasons = [
  {
    title: "25+ years on the tools",
    body: "Residential and commercial, NZQA qualified. Across building, demolition, landscaping and horticulture. Not much I haven't seen.",
  },
  {
    title: "I run your job like it's mine",
    body: "I've owned a business, so I get what's at stake. Put me on a corner of your operation and you can stop thinking about it.",
  },
  {
    title: "I solve problems, I don't create them",
    body: "Design, engineering, compliance. I spot it early and I sort it.",
  },
  {
    title: "If required, I can handle council inspections",
    body: "I can facilitate Council inspections and compliance pathways, working alongside the licensed builder where consent requires it. Inspector, photos, emails, sign-off coordination — handled.",
  },
  {
    title: "I lift the crew",
    body: "I enjoy mentoring younger builders. Bring me on and your team gets better, not just your job.",
  },
  {
    title: "No ego, no drama",
    body: "I take direction, I work clean, and I've got your back.",
  },
];

export const leadSkills = [
  {
    title: "Consultative approach",
    value: 96,
    quote:
      "There's a way of doing this, it'll cost a bit more but I promise it'll pay off in the end.",
  },
  {
    title: "Strategic recommendations",
    value: 95,
    quote:
      "He made a big call on drainage — the boring thing you can't see and don't want to spend money on. With all the recent floods, that's really paid off.",
  },
  {
    title: "Quality of work",
    value: 98,
    quote: "Really great quality — Bruce did an amazing job.",
  },
  {
    title: "Attention to detail",
    value: 97,
    quote:
      "He hid a powerpoint inside the bathroom cabinet so the toothbrush charges out of sight. That's the level of thought.",
  },
  {
    title: "Compliance knowledge",
    value: 94,
    quote:
      "He knew exactly what did and didn't need consent, so we weren't paying for sign-offs we didn't need.",
  },
];

export const strengths = [
  "Structural problem-solving",
  "Renovation specialist",
  "Compliance",
  "Design eye",
  "Attention to detail",
  "Leadership",
];

export const supportingSkills = [
  "Structural problem-solving",
  "Renovation depth — 25 years",
  "Design eye",
  "Flexible — fills any role on the team",
];

export const shortQuotes = [
  {
    quote:
      "He cares about what he does, and you can see it in the detail. That's the advantage of having him on your team.",
    author: "Cameron Holm — Create Renovations",
  },
  {
    quote:
      "Bruce renovated our bathroom and laundry. He led the whole project from design to build and sorted out all the other tradesmen. He knew exactly what did and didn't need consenting. A great experience start to finish.",
    author: "Marija & Rob, New Lynn",
  },
];

export const videoQuote = {
  paragraphs: [
    "Bruce would come to us and say, look, there's a way of doing this, it'll cost a bit more but it will pay off in the end.",
    "The drainage was one of those. A boring thing to spend money on because you can't see it, but it really paid off for us.",
    "Everything was just really great quality, and Bruce did an amazing job.",
    "It's the little details too, like the powerpoint he put inside the bathroom cabinet so your toothbrush charges out of sight.",
    "It's made the house so much more functional. It looks miles nicer, but it works much better as well.",
  ],
  tags: [
    "consultative approach",
    "strategic recommendations",
    "quality of work",
    "attention to detail",
  ],
};

export const credentials = [
  "NZQA Carpentry Certification",
  "GST registered",
  "Site Safe Passport",
  "St John First Aid Level 1",
  "Certificate of Horticultural Practice (Bay of Plenty Polytechnic)",
  "Certificate in Advanced Landscape and Design Technology (Unitec)",
  "Cladding and aluminium joinery specialist",
];

export const navLinks = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Why me", href: "#why" },
  { label: "Contact", href: "#contact" },
];
